export const TRIAL_DEFAULTS = {
  maxCommunities: 30,
  maxGroups: 600,
  maxMembers: 3000,
  maxStorage: 15,
} as const;

/** Deep-link that opens the choose-payment-method popup (not a switch). */
export const CHOOSE_PAYMENT_METHOD_PARAMS = {
  intent: 'instrument_reauthorization',
  collection: 'automatic',
  context: 'settlement_continuity',
} as const;

export const isChoosePaymentMethodDeepLink = (
  searchParams: URLSearchParams,
): boolean =>
  searchParams.get('intent') === CHOOSE_PAYMENT_METHOD_PARAMS.intent &&
  searchParams.get('collection') === CHOOSE_PAYMENT_METHOD_PARAMS.collection &&
  searchParams.get('context') === CHOOSE_PAYMENT_METHOD_PARAMS.context;

export const pct = (used: number, max: number) => {
  if (!max || max <= 0) return 0;
  return Math.min(100, Math.round((used / max) * 100));
};
